import {IEmployeesService} from "../../domain/employees/IEmployeesService";
import {Employee} from "../../../../../server/src/base/entities/employee/Employee";
import {Employees} from "../../../../../server/src/base/entities/employee/Employees";
import {ApiAccessService} from "../api/ApiAccessService";
import {IFileUploadService} from "../../domain/files/IFileUploadService";

export class EmployeesService implements IEmployeesService{

    constructor(private apiAccessService:ApiAccessService, private fileUploadService:IFileUploadService){

    }

    Add(employee: Employee, file:File): Promise<Employee> {
        return this.apiAccessService.PostReturn('employee/add', employee).then(employee => {
            let fileUpdated = new File([file], this.BuildPictureName(employee, file), {type: file.type});
            return this.fileUploadService.Upload(fileUpdated).then(pictureUrl => {
                employee.picture = pictureUrl;
                return this.apiAccessService.PostReturn('employee/add', employee);
            }).catch(error => {
                return Promise.reject(error);
            })
        })
    }

    BuildPictureName(employee: Employee, file:File){
        return employee.id + this.GetExtension(file);
    }

    GetExtension(file:File):string{
        let url = file.name;
        return url.slice(url.lastIndexOf('.'), url.length);
    }

    GetAll(): Promise<Employees> {
        return this.apiAccessService.Get('employees', Employees).then(employees => {
            return new Employees(this.SortSchiltzFirst(employees.Value()));
        })
    }

    SortSchiltzFirst(employees:Array<Employee>):Array<Employee>{
        let sorted:Array<Employee> = [];
        let other:Array<Employee> = [];
        for(let employee of employees){
            if(employee.name.includes('Schiltz')){
                sorted.push(employee)
            }
            else{
                other.push(employee);
            }
        }
        sorted = sorted.concat(other);
        return sorted;
    }

    Remove(employee: Employee): Promise<void> {
        return this.apiAccessService.Delete('employee/remove/' + employee.id);
    }

}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/employees/EmployeesService.ts